// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___15F5q","rootSuccess":"styles__rootSuccess___JnWH7","lessMarginIcon":"styles__lessMarginIcon___1qKNS","textSuccess":"styles__textSuccess___2vZNZ","protocol":"styles__protocol___1moJW","action":"styles__action___WT4_b","modalTitle":"styles__modalTitle___2mgf6","smallTextSuccess":"styles__smallTextSuccess___1Yi9b","lighterDivline":"styles__lighterDivline___3C-sT","ctaButtonTutorial":"styles__ctaButtonTutorial___3W2-K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalSuccess/styles.css
// module id = 2754
// module chunks = 0